/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to update a feature in the catalog (all fields optional)
 * @export
 * @interface UpdateFeatureRequest
 */
export interface UpdateFeatureRequest {
    /**
     * Display name
     * @type {string}
     * @memberof UpdateFeatureRequest
     */
    displayName?: string;
    /**
     * Description
     * @type {string}
     * @memberof UpdateFeatureRequest
     */
    description?: string;
    /**
     * Detailed description for catalog and help views
     * @type {string}
     * @memberof UpdateFeatureRequest
     */
    detailedDescription?: string;
    /**
     * Category
     * @type {string}
     * @memberof UpdateFeatureRequest
     */
    category?: string;
    /**
     * Pricing model: PER_USER, ALL_IN, METERED
     * @type {string}
     * @memberof UpdateFeatureRequest
     */
    pricingModel?: string;
    /**
     * Metering dimension (if METERED)
     * @type {string}
     * @memberof UpdateFeatureRequest
     */
    meteringDimension?: string;
    /**
     * SKU
     * @type {string}
     * @memberof UpdateFeatureRequest
     */
    sku?: string;
    /**
     * Price impact in cents
     * @type {number}
     * @memberof UpdateFeatureRequest
     */
    priceImpactCents?: number;
    /**
     * Release state: ALPHA, BETA, GA, PLANNED
     * @type {string}
     * @memberof UpdateFeatureRequest
     */
    releaseState?: string;
    /**
     * For GA: date became GA. For ALPHA/BETA/PLANNED: target or expected release date.
     * @type {Date}
     * @memberof UpdateFeatureRequest
     */
    releaseDate?: Date;
    /**
     * UI route
     * @type {string}
     * @memberof UpdateFeatureRequest
     */
    uiRoute?: string;
    /**
     * Permission required
     * @type {string}
     * @memberof UpdateFeatureRequest
     */
    permissionRequired?: string;
    /**
     * Feature IDs this feature depends on
     * @type {Array<string>}
     * @memberof UpdateFeatureRequest
     */
    requiresFeatures?: Array<string>;
    /**
     * Sort order
     * @type {number}
     * @memberof UpdateFeatureRequest
     */
    sortOrder?: number;
    /**
     * Whether feature is active
     * @type {boolean}
     * @memberof UpdateFeatureRequest
     */
    active?: boolean;
}

/**
 * Check if a given object implements the UpdateFeatureRequest interface.
 */
export function instanceOfUpdateFeatureRequest(value: object): value is UpdateFeatureRequest {
    return true;
}

export function UpdateFeatureRequestFromJSON(json: any): UpdateFeatureRequest {
    return UpdateFeatureRequestFromJSONTyped(json, false);
}

export function UpdateFeatureRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateFeatureRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'description': json['description'] == null ? undefined : json['description'],
        'detailedDescription': json['detailedDescription'] == null ? undefined : json['detailedDescription'],
        'category': json['category'] == null ? undefined : json['category'],
        'pricingModel': json['pricingModel'] == null ? undefined : json['pricingModel'],
        'meteringDimension': json['meteringDimension'] == null ? undefined : json['meteringDimension'],
        'sku': json['sku'] == null ? undefined : json['sku'],
        'priceImpactCents': json['priceImpactCents'] == null ? undefined : json['priceImpactCents'],
        'releaseState': json['releaseState'] == null ? undefined : json['releaseState'],
        'releaseDate': json['releaseDate'] == null ? undefined : (new Date(json['releaseDate'])),
        'uiRoute': json['uiRoute'] == null ? undefined : json['uiRoute'],
        'permissionRequired': json['permissionRequired'] == null ? undefined : json['permissionRequired'],
        'requiresFeatures': json['requiresFeatures'] == null ? undefined : json['requiresFeatures'],
        'sortOrder': json['sortOrder'] == null ? undefined : json['sortOrder'],
        'active': json['active'] == null ? undefined : json['active'],
    };
}

export function UpdateFeatureRequestToJSON(json: any): UpdateFeatureRequest {
    return UpdateFeatureRequestToJSONTyped(json, false);
}

export function UpdateFeatureRequestToJSONTyped(value?: UpdateFeatureRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'displayName': value['displayName'],
        'description': value['description'],
        'detailedDescription': value['detailedDescription'],
        'category': value['category'],
        'pricingModel': value['pricingModel'],
        'meteringDimension': value['meteringDimension'],
        'sku': value['sku'],
        'priceImpactCents': value['priceImpactCents'],
        'releaseState': value['releaseState'],
        'releaseDate': value['releaseDate'] == null ? undefined : ((value['releaseDate']).toISOString().substring(0,10)),
        'uiRoute': value['uiRoute'],
        'permissionRequired': value['permissionRequired'],
        'requiresFeatures': value['requiresFeatures'],
        'sortOrder': value['sortOrder'],
        'active': value['active'],
    };
}

